"use strict";

var _interopRequireDefault = require("/code/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _doctor = require("@/api/doctor");
var _Export2Excel = require("@/utils/Export2Excel");
var _utils = require("@/utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      date: '',
      profitOptions: [{
        key: 1,
        display_name: '渠道商'
      }, {
        key: 2,
        display_name: '运维团队'
      }, {
        key: 3,
        display_name: '设备所属单位'
      }, {
        key: 4,
        display_name: 'C端机构'
      }, {
        key: 5,
        display_name: 'TTS专家工作室'
      }, {
        key: 6,
        display_name: 'TTS方案归属团队'
      }, {
        key: 10,
        display_name: '新汉方公司'
      }],
      listQuery: {},
      tableData: []
    };
  },
  created: function created() {},
  methods: {
    checkPermission: _permission.default,
    exportTest: function exportTest() {
      if (this.listQuery.time === '' || this.listQuery.time === undefined || this.listQuery.time === null) {
        this.$message({
          type: 'error',
          message: '请先查询时间!'
        });
      } else {
        this.exportExcel();
      }
    },
    exportExcel: function () {
      var _exportExcel = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var _this = this;
        var multiHeader, tHeader, filterVal, list, data, merges;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _doctor.getDoctorCommission)(this.listQuery).then(function (response) {
                if (response.data) {
                  _this.tableData = response.data;
                  console.log(_this.tableData);
                }
              });
            case 2:
              multiHeader = [['医生分润报表', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''], ['报表时间', this.listQuery.time, '', '', '', '', '', '', '上月结余', '', '', '本月', '', '', '', '合计', '', '']]; // 一、二级表头
              tHeader = ['专家编号', '专家姓名', '所属渠道', '推荐人编号', '推荐人姓名', '开户行', '账号', '上月待收', '本月实收', '剩余待收', '处方单数', '预计收入', '实际收入金额', '待收服务金额', '待收服务金额', '服务实收金额', '待收服务金额']; // 三级表头
              filterVal = ['doctor_user_id', 'doctor_name', 'qudao', 'doctor_recommender_id', 'doctor_recommender_name', 'doctor_accounts_name', 'doctor_accounts_no', 'ready_amounts', 'actual_amounts_month', 'remaining_amounts', 'treat_num', 'pre_receivables', 'actual_receivables', 'pre_service_amounts', 'total_ready_amounts', 'total_actual_amounts', 'total_remaining_amounts']; // 表头所对应后台返回的字段
              // const data = this.excelData.map(v => filterVal.map(j => v[j]));//这一行和下面得六行代码是一样得作用的
              list = this.tableData; // if (this.tableData === 0) {
              //   list = this.tableData
              // } else {
              //   list = this.tableData
              // }
              data = this.formatJson(filterVal, list); // 格式化
              console.log(data);
              // 如果没有合并得从上往下写，遇到开始合并单元格的，从左往右得单行写，从上到下，直到写完整
              merges = ['A1:H1', 'B2:H2', 'I2:K2', 'L2:O2', 'P2:R2'];
              (0, _Export2Excel.export_json_to_excel)({
                multiHeader: multiHeader,
                // 这里是第一行的表头
                header: tHeader,
                // 这里应该是算第二行的表头
                data: data,
                // 数据
                merges: merges,
                // 合并行
                filename: '医生分润报表' + '_' + new Date().getTime(),
                autoWidth: true,
                bookType: 'xlsx'
              });
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function exportExcel() {
        return _exportExcel.apply(this, arguments);
      }
      return exportExcel;
    }(),
    formatJson: function formatJson(filterVal, jsonData) {
      return jsonData.map(function (v) {
        return filterVal.map(function (j) {
          if (j === 'timestamp') {
            return (0, _utils.parseTime)(v[j]);
          } else {
            return v[j];
          }
        });
      });
    }
  }
};